<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <base-layout-sidebar class="sidebar-container" />
    <base-layout-header />
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
        <base-layout-tabs v-if="needTagsView" />
      </div>
      <div class="app-main-scroll-container">
        <el-scrollbar class="scrollbar" wrap-class="scrollbar-wrapper" :native="false">
          <base-layout-main />
        </el-scrollbar>
      </div>
      <div v-if="false" class="footer">
        {{ $t('layout.BaseLayout.2596049-0') }}
        <!-- {{ footerContent }} -->
      </div>
    </div>
  </div>
</template>

<script>
// import RightPanel from '@/framework/components/RightPanel'
import BaseLayoutMain from './BaseLayoutMain'
import BaseLayoutHeader from './BaseLayoutHeader'
import BaseLayoutSidebar from './BaseLayoutSidebar'
import BaseLayoutTabs from './BaseLayoutTabs'
import ResizeMixin from './mixin/ResizeHandler'
import Hamburger from '@/framework/components/Hamburger'
import { mapState } from 'vuex'

export default {
  name: 'BaseLayout',
  components: {
    BaseLayoutMain,
    BaseLayoutHeader,
    // RightPanel,
    // Settings,
    BaseLayoutSidebar,
    BaseLayoutTabs,
    Hamburger
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      noticeNumber: state => state.app.noticeNumber,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/framework/styles/mixin.scss";
  @import "~@/config/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }

    .hamburger-container {
      line-height: $tabsHeight;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color:transparent;
      border-width: 0px;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
    .app-main-scroll-container {
      height: calc(100vh - #{$tabsHeight} - #{$headerHeight});
      width: 100%;
      .scrollbar {
        height: 100%;
        .scrollbar-wrapper {
          overflow-x: hidden;
        }
      }
    }
    .footer {
      height: $footerHeight;
      background: $footerBackgroundColor;
      color: $footerFontColor;
      font-size: $footerFontSize;
      text-align: $footerAlign;
      width: 100%;
      line-height: $footerHeight;
      border-top: 1px solid $footerBorderColor;
    }
  }



  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
